

export default class Receipt {
    constructor(gcid, tagId, transactionId, receiveDateTime, warehouseId, warehouseName, sublocationId, sublocationName, receiverId, receiverName, lot,  reference, receiverComment, receiptLines, receiptStatus, tagUnitQty, tagPalletQty, qaLocationId, driverId, driverName, licensePlate, receiverSignature, driverSignature, images){
        this.modelVersion = "v.01.04";
        this.gcid = gcid || "";
        this.transactionId = transactionId || "";
        this.tagId = tagId.toString() || "";
        this.receiveDateTime = receiveDateTime || "";
        this.warehouseId = warehouseId || "";
        this.warehouseName = warehouseName || "";
        this.sublocationId = sublocationId || "";
        this.sublocationName = sublocationName || "";
        this.receiverId = receiverId || "";
        this.receiverName = receiverName || "";
        this.lot = lot || "";
        this.reference = reference || "";
        this.qaLocationId = qaLocationId || "";
        this.receiverSignature = receiverSignature || "";
        this.driverId = driverId || "";
        this.driverName = driverName || "";
        this.driverLicensePlate = licensePlate || "";
        this.driverSignature = driverSignature || "";
        this.tagUnitQty = tagUnitQty || 0;  
        this.tagPalletQty = tagPalletQty || 0;

        this.lines = receiptLines || [];
        this.status = receiptStatus || {};
        this.images = images || [];

        this.receiptHash = "";
    }
}